module.exports = __webpack_public_path__ + "img/basics4.a3fbefcd.png";